import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../utils";
import { mfaCodeDigitVariants } from "./mfa-code-digit.styles";
/**
 * Single numeric cell for {@link MFACodeInput} (web).
 */
export const MFACodeDigit = forwardRef(({ value, onChange, onKeyDown, onPaste, index, className, autoComplete = "off", error = false, disabled = false, success = false, }, ref) => {
    const handleChange = (e) => {
        const digit = e.target.value.replace(/\D/g, "");
        if (digit.length > 1)
            return;
        onChange(digit);
    };
    return (_jsx("input", { ref: ref, type: "text", inputMode: "numeric", maxLength: 1, value: value, onChange: handleChange, onKeyDown: onKeyDown, onPaste: index === 0 ? onPaste : undefined, className: cn(mfaCodeDigitVariants({ error, disabled, success }), className), autoComplete: autoComplete, disabled: disabled }));
});
MFACodeDigit.displayName = "MFACodeDigit";
//# sourceMappingURL=MFACodeDigit.js.map